import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { BackendType } from '@starjack/utils';
import {
    ContestEntry,
    convertContestEntryFromResponse,
} from '@/models/contestEntry';

const baseUrl = urlBuilder('auth', 'contest-entries');

/** Both days inclusive, ISO dates (yyyy-MM-dd). */
export type ContestEntriesQuery = {
    from: string;
    to: string;
};

export const contestEntriesApi = baseApiAuthenticated.injectEndpoints({
    endpoints: (builder) => ({
        getContestEntries: builder.query<ContestEntry[], ContestEntriesQuery>({
            query: ({ from, to }) =>
                `${baseUrl}?${new URLSearchParams({ from, to }).toString()}`,
            transformResponse: (response: ContestEntry<BackendType>[]) =>
                response.map(convertContestEntryFromResponse),
        }),
    }),
});

export const { useLazyGetContestEntriesQuery } = contestEntriesApi;
